import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { loading } from '@/decorators';
import LogList from './logList.vue';
import AmountList from './amountList.vue';

var ViewDetail = function (_super) {
  __extends(ViewDetail, _super);

  function ViewDetail() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.columns = [];
    _this.loadingStatus = false;
    _this.detailsData = {};
    _this.dateilBaseInfo = [];
    _this.tabList = [{
      value: 'amountList',
      text: _this.t('费用明细')
    }, {
      value: 'logList',
      text: _this.t('流水日志')
    }];
    _this.activeName = _this.tabList[0].value;
    return _this;
  }

  ViewDetail.prototype.created = function () {
    this.columns = [{
      title: this.t('单号'),
      dataIndex: 'order_number',
      filterEmpty: true
    }, {
      title: this.t('参考号'),
      dataIndex: 'reference_number',
      filterEmpty: true
    }, {
      title: this.t('账户编号'),
      dataIndex: 'account_code',
      filterEmpty: true
    }, {
      title: this.t('总金额'),
      align: 'right',
      dataIndex: 'total_amount'
    }, {
      title: this.t('币种'),
      dataIndex: 'currency_code',
      filterEmpty: true
    }];
  };

  ViewDetail.prototype.queryTypeTariffTradeDetails = function () {
    return __awaiter(this, void 0, Promise, function () {
      var params, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.detailsData = {};
            params = {
              order_number: this.rowData.order_number
            };
            return [4, this.$api.finance.queryTypeTariffTradeDetails(params)];

          case 1:
            data = _a.sent().data;
            this.detailsData = data || {};
            this.dateilBaseInfo = [this.detailsData.base_info] || [];
            return [2];
        }
      });
    });
  };

  ViewDetail.prototype.handleClose = function () {
    this.$emit('update:visible', false);
  };

  ViewDetail.prototype.handleVisible = function () {
    if (this.visible) {
      this.queryTypeTariffTradeDetails();
    }
  };

  __decorate([Prop({
    type: String,
    "default": false
  })], ViewDetail.prototype, "visible", void 0);

  __decorate([Prop({
    type: Object,
    "default": function _default() {}
  })], ViewDetail.prototype, "rowData", void 0);

  __decorate([loading('loadingStatus')], ViewDetail.prototype, "queryTypeTariffTradeDetails", null);

  __decorate([Watch('visible', {
    deep: true,
    immediate: true
  })], ViewDetail.prototype, "handleVisible", null);

  ViewDetail = __decorate([Component({
    components: {
      LogList: LogList,
      AmountList: AmountList
    }
  })], ViewDetail);
  return ViewDetail;
}(Vue);

export default ViewDetail;